// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1u1iH","icon":"styles_icon__2iwbj"};